export const attendance = {
  table: {
    date: '日付',
    total: '合計',
    export: 'エクスポート',
    hour: '(単位　ｈ)',
    id: '個人CD',
    fullName: '個人名',
    contactHours: '契約時間',
    workingTime: '作業時間',
    addTabs: '追加タブ',
    name: '名前',
    process: '工程',
    inOut: 'IN or OUT',
    time: '時刻',
    addEmployee: 'スタッフの追加',
    create: '出席の作成',
    update: '編集',
    delete: 'データ削除',
    save: '保存',
    totalError: 'エラー数',
  },
  pageHeader: {
    title: 'データ修正、エラーチェック	',
    titleError: 'エラーチェック',
  },
  filter: {
    filterDay: '日付別で表示',
    filterEmployee: '個人指定',
    error: 'エラー指定',
    false: '指定あり',
    true: '指定なし',
    defaultValue: '指定なし',
    specified: '指定あり',
    gender: '性別',
    position: '職位',
    department: '部署',
  },
}
